import { DataGridCellParams } from "@components/common/data-grid/adm-data-grid-types";
import { AdmMember } from "@custom-types/base-types";

/** The column definition for the search members table with the field property typed */
export type SearchMembersTableGridColDef = DataGridCellParams<
  AdmMember,
  SearchMembersTableColumnField
>;

/** The column fields that can be used in the search members table */
export type SearchMembersTableColumnField =
  "name" | "email" | "workspace" | "createdAt" | "status" | "options";

/** The labels for the columns in the search members table */
export const SEARCH_MEMBERS_TABLE_COLUMN_LABELS: Record<
  SearchMembersTableColumnField,
  string
> = {
  name: "Name",
  email: "Email",
  workspace: "Workspace",
  createdAt: "Created At",
  status: "Status",
  options: "",
};
